import styled from 'styled-components'

export const LandingPageStyle = styled.div`
  color: pink;
`
